import type { MaybeRef } from 'vue'
import { InvoiceCarrierType } from '@/types/invoice'
import type { InvoiceInfo } from '@/types/invoice'

export function useInvoiceDisplay(invoiceInfo: MaybeRef<InvoiceInfo | null | undefined>) {
  const { t } = useI18n()

  const info = computed(() => unref(invoiceInfo))

  const invoiceNumber = computed(() => info.value?.invoice_number || null)

  const isMemberCarrier = computed(() => info.value?.carrier_type === InvoiceCarrierType.EasyCard)
  const isMobileBarcodeCarrier = computed(() => info.value?.carrier_type === InvoiceCarrierType.MobileBarcode)
  const isCompanyTaxCarrier = computed(() => info.value?.carrier_type === null && !!info.value?.tax_id)

  const invoiceCarrierDisplay = computed(() => isMemberCarrier.value || isMobileBarcodeCarrier.value || isCompanyTaxCarrier.value)
  const invoiceSection = computed(() => !!(invoiceNumber.value || invoiceCarrierDisplay.value))

  const invoiceCarrierRow = computed<{ label: string; value: string } | null>(() => {
    if (isMemberCarrier.value) return { label: t('detail_invoice_carrier'), value: '' }
    if (isMobileBarcodeCarrier.value) return { label: t('detail_phone_barcode'), value: info.value?.carrier_num ?? '' }
    if (isCompanyTaxCarrier.value) return { label: t('detail_vat_number'), value: info.value?.tax_id ?? '' }
    return null
  })

  return {
    invoiceNumber,
    invoiceSection,
    invoiceCarrierRow,
  }
}
